import { Box, Typography, TextField, Button, CircularProgress, InputAdornment } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import COLORS from '../../../../constants/colors';
import { useState } from 'react';
import Header from '../Register/Header';
import SnackbarAlert from '../Reusbale/SnackbarAlert'; // Snackbar for messages
import baseURL from '../config'; // API base URL
import { Link, useNavigate } from 'react-router-dom';
import Footer from '../../../Reusable/Footer';
import { toast } from 'react-toastify';

const ResetPassword = () => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });

    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        if (!email) {
            toast.error('Email is required!');
            setLoading(false);
            return;
        }

        try {
            const response = await fetch(`${baseURL}/auth/user/forgot-password`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email }),
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || 'Error sending reset link');
            }

        
            toast.success('Reset link sent! Check your email.');


            // Redirect to login after 3 seconds
            setTimeout(() => navigate('/user/login'), 3000);

        } catch (error) {
          
            toast.error(error.message);

            
        } finally {
            setLoading(false);
        }
    };

  
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <Header />
            
            {/* Centering Box */}
            <Box sx={{ 
                flex: 1, 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center' 
            }}>
                <Box sx={{ py: 3, px: 3, maxWidth: 500, width: '100%', textAlign: 'center' }}>
                    {/* Header */}
                    <Typography variant="h4" fontWeight="bold" color={COLORS.primary} mb={2}>
                        Reset Password
                    </Typography>
                    <Typography variant="body1" color={COLORS.text} mb={4}>
                        Enter your email and we will send you a password reset link.
                    </Typography>

                    {/* Reset Password Form */}
                    <Box component="form" noValidate autoComplete="off" onSubmit={handleSubmit}>
                        {/* Email Field */}
                        <TextField
                            name="email"
                            label="Email Address"
                            variant="outlined"
                            fullWidth
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            sx={{
                                mb: 2,
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '10px',
                                    fontSize: '1rem',
                                    '& input': { padding: '14px' }, // Increased height
                                },
                            }}
                            InputLabelProps={{ style: { color: COLORS.primary, fontSize: '1rem' } }} // Increased font size
                            InputProps={{
                                style: { color: COLORS.text },
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <FontAwesomeIcon icon={faEnvelope} style={{ color: COLORS.primary }} />
                                    </InputAdornment>
                                ),
                            }}
                        />

                        {/* Submit Button */}
                        <Button
                            type="submit"
                            variant="contained"
                            fullWidth
                            sx={{
                                backgroundColor: COLORS.primary,
                                color: COLORS.white,
                                borderRadius: '10px',
                                boxShadow:0,
                                py: 1.2, // Increased padding
                                fontSize: '1rem',
                                textTransform: 'none',
                                '&:hover': { backgroundColor: COLORS.secondary },
                                display: 'flex',
                                boxShadow:0,
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '10px', // Space between icon and text
                            }}
                        >
                            {loading ? (
                                <>
                                    <CircularProgress size={22} sx={{ color: COLORS.white }} />
                                    <Typography sx={{color:'white'}}>Processing...</Typography>
                                </>
                            ) : 'Send Reset Link'}
                        </Button>
                    </Box>

                    {/* Back to Login */}
                    <Box mt={2}>
                        <Typography variant="body2" color={COLORS.text}>
                            Remember your password?{' '}
                            <Link to="/user/login" style={{ color: COLORS.primary, textDecoration: 'none', fontWeight: 'bold' }}>
                                Login
                            </Link>
                        </Typography>
                    </Box>
                </Box>
            </Box>

      
            <Footer />
        </Box>
    );
};

export default ResetPassword;
